import { api } from "../AxiosInstance";

export function getAllHubsApi(params) {
  return api().get("/api/MicroHub/GetMicroHubs", { params });
}

export function createHubApi(data) {
  return api().post("/api/MicroHub/Create", data);
}

export function getHubByIdApi(params) {
  return api().get("/api/MicroHub/GetMicroHubById", { params });
}

export function editHubApi(data) {
  return api().put("/api/MicroHub/EditMicrohub", data);
}

export function deleteHubApi(data) {
  return api().post("/api/MicroHub/DeleteMicroHub", data);
}

export function assignPolygonToHubApi(data) {
  return api().post("/api/Dispatch/AssignClusterToMicrohub", data);
}

export function removeHubFromPolygonApi(data) {
  return api().post("/api/Dispatch/DeleteClusterFromMicrohub", data);
}
